import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SbIconComponent } from './sb-icon.component';

const COMPONENTS = [
  SbIconComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  entryComponents: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
  ],
})
export class SbIconsModule { }
